import PropTypes from 'prop-types'

import InputBase from './InputBase'
import MaskTextButton from './MaskTextButton'
import Wrapper from './Wrapper'

import './passwordInput.scss'

export default class PasswordInput extends InputBase {
  constructor(props) {
    const newProps = {
      ...props,
      showPassword: false
    }

    super(props)

    this.setInitialState(newProps) // weird workaround for ie shallow copy: http://babeljs.io/docs/plugins/transform-proto-to-assign/

    this.onFormElementChange = this.onFormElementChange.bind(this)
    this.toggleMask = this.toggleMask.bind(this)
  }

  toggleMask(event) {
    event.preventDefault()

    this.setState({showPassword: !this.state.showPassword})
  }

  render() {
    const {wrap, ...otherProps} = this.props

    if (wrap) {
      return (
        <div className='password-input'>
          <Wrapper {...otherProps} errors={this.errors()}>
            <InputElement {...otherProps} type={this.state.showPassword ? 'text' : 'password'} value={this.state.formValue} onChange={this.onFormElementChange} />
            <MaskTextButton
              className='mask-icon-and-text'
              showText={this.state.showPassword}
              toggleButton={this.toggleMask}
            />
          </Wrapper>
        </div>
      )
    } else {
      return (
        <div className='password-input'>
          <InputElement {...otherProps} type={this.state.showPassword ? 'text' : 'password'} value={this.state.formValue} onChange={this.onFormElementChange} />
          <MaskTextButton
            className='mask-icon-and-text'
            showText={this.state.showPassword}
            toggleButton={this.toggleMask}
          />
        </div>
      )
    }
  }
}

PasswordInput.propTypes = {wrap: PropTypes.bool}
PasswordInput.defaultProps = {wrap: true}

const InputElement = props => (
  <input {...props} type={props.type ? props.type : 'text'} />
)

InputElement.propTypes = {type: PropTypes.string}
